import Icon from '@ant-design/icons';
import { Modal } from 'antd';
import classNames from 'classnames';
import { useContext, useMemo } from 'react';

import CloseSvg from '@/components/Icon/svgs/close.svg';
import NewChatSvg from '@/components/Icon/svgs/new-chat.svg';
import { CONTAINER_EVENT } from '@/components/chat-app/utils/utils';
import { ContextGeniusLayout } from '@/context/GeniusLayout';
import HomeContext from '@/context/HomeContext';
import { LAYOUT_SIZE } from '@/hooks/useLayoutSize';
import useStorage from '@/hooks/useStorage';
import { EVENT } from '@/utils/event';

import PAChat from '../PAChat';
import ChatTitle from './components/chatTitle';
import styles from './index.less';

const ModalChat = () => {
  const { chatStatus } = useContext(ContextGeniusLayout);
  const [layoutSize] = useStorage('layoutSize');

  const { chatHomepageRoute, chatCircleRoute } = useContext(HomeContext);

  const open = useMemo(() => {
    if (layoutSize) {
      return layoutSize !== LAYOUT_SIZE.LARGE && chatStatus !== 'hide';
    }

    return false;
  }, [chatStatus, layoutSize]);

  return (
    <Modal
      className={classNames(styles.chatModal, {
        [styles.friendHomepage]: !!chatHomepageRoute,
        [styles.circleChat]: !!chatCircleRoute
      })}
      closeIcon={false}
      footer={null}
      forceRender={true}
      mask={false}
      open={open}
      wrapClassName="!z-[500] !overflow-hidden"
    >
      <div className="flex flex-col w-full h-full" id="modal-chat-container">
        {chatHomepageRoute || chatCircleRoute ? null : (
          <div className=" !z-10 flex items-center gap-2">
            <div
              className={
                'box-border w-[36px] h-[36px] bg-[rgba(254,253,255,0.6)] rounded-[18px] p-2 cursor-pointer'
              }
              onClick={() => {
                dispatchEvent(new Event(CONTAINER_EVENT.ONBOARD));
                dispatchEvent(new Event(CONTAINER_EVENT.CLOSE_SESSION));
                dispatchEvent(new Event(EVENT.CLOSE_TASK_LIST));
                dispatchEvent(new Event(EVENT.NEW_CHAT_CALLBACK));
                dispatchEvent(new CustomEvent(CONTAINER_EVENT.CHAT_INPUT_FOCUS));
              }}
            >
              <Icon className="text-[20px] text-[#2f2f40]" component={NewChatSvg} />
            </div>

            {layoutSize !== LAYOUT_SIZE.LARGE && <ChatTitle layoutSize={layoutSize} />}

            <div
              className={
                'box-border w-[36px] h-[36px] ml-auto bg-[rgba(254,253,255,0.6)] rounded-[18px] p-2 cursor-pointer'
              }
              onClick={() => {
                dispatchEvent(new Event(EVENT.HIDE_MODAL_CHAT));
              }}
            >
              <Icon className="text-[20px] text-[#2f2f40]" component={CloseSvg} />
            </div>
          </div>
        )}

        {layoutSize !== LAYOUT_SIZE.LARGE ? (
          <PAChat className="flex-1 !p-0" inMobileDevice={true} />
        ) : null}
      </div>
    </Modal>
  );
};

export default ModalChat;
